<template>
    <div>
      <div class="content" id="content">
        <div class="newsdetail" id="newsdetail">
        <div class="biaoti" id="biaoti">
             <div class="return"  id="return" @click="returnback()" >
                <el-icon class="icons"><Back /></el-icon>
            </div>
            <p class="newstitle" id="newstitle">{{title}}</p>
            <p class="time" id="time">{{time}}</p>
            </div>
        
        <div class="newsdivide" id="newsdivede">
        </div>
        <div class="newscontain" id="newscontain">
          <div class="details" id="details">
            <div class="detailsinfo">
           
              <Editor v-model="details" previewOnly/>
              
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </template>

  <script>
  import { ElMessage } from "element-plus";
  import { useRouter, useRoute } from 'vue-router';
  import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
  import { defineComponent } from 'vue';
  import Editor from 'md-editor-v3';
  import 'md-editor-v3/lib/style.css';
  export default {
    name: 'VueTemplateDemo',
    components: { Editor },
    data() {
      return {
        isPC: this.isPCNot(),
        dataSource: {
          totalCount: 50,
          pageSize: 5,
          pageNo: 1,
        },
        newsdata:[],
        title:"",
        details:"",
        time:"",
      };
    },
    methods: {
      changestyle(){
        //如果是安卓端
        if(this.isPC==false){
          //新闻标题
          var biaoti=document.getElementById("biaoti").style;  
          biaoti.gridTemplateColumns="8% 72% 20%";
          //返回按钮
          var return1=document.getElementById("return").style;  
					return1.left="10%";
          return1.top="1.2em";
          return1.width="1.3em";
          //标题内容
          var newstitle=document.getElementById("newstitle").style;  
          newstitle.fontSize="0.9em";
          //时间
          var time=document.getElementById("time").style;  
          time.fontSize="0.7em";
          time.paddingTop="2em";
          //内容
          var newscontain=document.getElementById("newscontain").style;  
          newscontain.marginLeft="0";
          
          var details=document.getElementById("details").style;  
          details.paddingLeft="0";
          details.paddingRight="0";
        }
        else{
        }
      },
      //判断是否为PC
		  isPCNot() {
          var userAgentInfo = navigator.userAgent;
          var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
          var flag = true;
          for (var v = 0; v < Agents.length; v++) {
              if (userAgentInfo.indexOf(Agents[v]) > 0) {
                  flag = false;
                  break;
              }
          }
          return flag;
      },
      getcontain(id){
            let config = {
				headers: { "Content-Type": "multipart/form-data" }
			};
			//添加请求头
			let param = new FormData(); //创建form对象
            param.append("id", id);
			this.$axios.post("http://82.157.23.29:5000/getnewsbyid", param, config)
			.then((response) =>{
				this.newsdata=response.data;
                this.title=this.newsdata[0].title;
                this.details=this.newsdata[0].cont;
                this.time=this.newsdata[0].time;
                var str=this.details.slice(0, 4)
                if(str=="http"){
                  window.location.href=this.details
                }
			});
        },
        returnback(){
            history.back()
        }

    },
    created() {
        let id = this.$route.query.id;
        this.getcontain(id);
        
    },
    mounted(){
      this.changestyle();
    },
    computed: {},
  };
  </script>
  <style>
  :-webkit-scrollbar {
    width: 5px;
    height: 14px;
  }
  
  ::-webkit-scrollbar-thumb {
    background-color: #b6b6b6;
  }
  </style>
  <style scoped>
  .details{
    min-height:100vh;
    padding-left: 7em;
    padding-right: 7em;
  }
  .content {
    width: 80%;
    margin: 0px auto 0px auto;
    height: 100%;
  }
  .newsdetail {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #f9f9f9;
    margin: 0 auto;
  }
  .newstitle {
    font-size: 2em;
    color: #1362db;
    font-weight: bold;
    min-height: 1.2em;
    padding-top: 1em;
      text-align:center;
      width:100%
  }
  .newsdivide {
    height: 3em;
    width: 100%;
    background: url("../../assets/divide3.png") no-repeat;
    background-size: 100% 100%;
  }
  
  .footer {
    height: 30vh;
    background-color: #586885;
  }
  
  .demo-tabs >>> .el-tabs__item {
    font-size: 1.07em;
    font-family: "黑体";
  }
  .newscontain {
    width: 100%;
    height: 100%;
    margin-left: 2em;
    background-color: #ffffff;
  }
  
  .bigimg_1 {
    font: 800 70px/1 "Source Sans Pro", Arial, sans-serif;
    background: transparent;
    text-transform: uppercase;
    color: #ffffff;
    text-align: center;
    position: absolute;
    top: 15%;
    width: 97%;
  
    text-shadow: 0 1px 0 hsl(173, 11%, 85%), 0 2px 0 hsl(0, 0%, 84%),
      0 3px 0 hsl(174, 5%, 70%), 0 4px 0 hsl(174, 5%, 66%),
      0 5px 0 hsl(174, 5%, 64%), 0 6px 0 hsl(174, 5%, 62%),
      0 7px 0 hsl(174, 5%, 61%), 0 8px 0 hsl(174, 5%, 60%),
      0 0 5px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.2),
      0 3px 5px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.2),
      0 10px 10px rgba(0, 0, 0, 0.2), 0 20px 20px rgba(0, 0, 0, 0.3);
  }
  
  .footer {
    background-color: #444444;
    height: 100%;
    width: 100%;
    padding: 2vh 0;
  }
  
  .footer p {
    color: white;
    font-size: 16px;
    display: block;
    line-height: 38px;
  }
  .arrange {
    height: 54vh;
  }
  .bodys {
    background-color: #f9f9f9;
  }
  .ogh2 {
    position: absolute;
    width: 20vw;
    top: 30%;
    right: 29%;
    font-size: 1.7em;
    color: #a7aba9;
  }
  
  .header {
    position: relative;
    z-index: 100;
    min-width: 1000px;
    height: 100%;
    display: grid;
    background: #2f83e5;
    grid-template-columns: 3% 12% 70% 8% 7%;
  }
  
  .logoh {
    position: relative;
    top: 30%;
    color: white;
  }
  .logos {
    display: grid;
    grid-template-columns: 30% 70%;
  }
  a:hover,
  a:link,
  a:visited,
  a:active,
  a:focus {
    color: ghostwhite;
    text-decoration: none;
  }
  .login {
    position: relative;
    top: 30%;
  }
  .newstitle {
    font-size: 2em;
    color: #1362db;
    font-weight: bold;
    min-height: 1.2em;
    padding-top: 1em;
  }
  .newsdivide {
    height: 3em;
    width: 100%;
    background: url("../../assets/divide3.png") no-repeat;
    background-size: 100% 100%;
  }
  .detailsinfo {
    position: relative;
    width: 100%;
    margin: 0px auto 0px auto;
    padding-top: 2em;
    padding-bottom: 6em;
    height: 100%;
  }
  .return{
    position:relative;
    left: 60%;
    top: 60%;
    width: 3em;
    height: 2.5em;
    z-index:1000
  }
  .icons{
    width: 100%;
    height: 100%;
  }
  .el-icon svg {
    height: 100%;
    width: 100%;
}
.biaoti{
  display:grid;
  grid-template-columns:20% 60% 20%;
}
.time{
    padding-top: 5em;
}
  </style>